/*
 README

 If you are using this in a modal, you need to add v-if="modalIsOpen" logic
 or this directive will fire when the input is not visible, i.e. auto focus won't work.
 You need it to fire when the modal opens.
 
*/

export default {
    bind: function(el) {},
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        // Focus the element
        if (el instanceof HTMLInputElement) {
            // this works on standard <input>s
            el.focus();
        } else {
            // this works on vue-wysiwyg
            let contenteditable = el.querySelector("[contenteditable=true]");
            if (contenteditable !== null) {
                contenteditable.focus();
            } else {
                // this works on iView <Input>
                el.querySelector("input").focus();
            }
        }
    },
    update: function(el) {},
};
